module.exports = __webpack_public_path__ + "static/img/30.043299f4.jpeg";